import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-about',
    'templateUrl': './about.page.html',
    'styleUrls': ['./about.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class AboutPage extends ViewBasePage implements OnInit, OnDestroy {
    public debugMode = true;

    constructor(injector: Injector) {
        super(injector);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        // this.initMoreMenu();
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_ABOUT);
    }

    public onReset() {
        // console.log('In onReset()');
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public onVersionClick() {
        this.router.navigateByUrl('/about/version');
    }

    public onReleaseNotesClick() {
        this.router.navigateByUrl('/about/releaseNotes');
    }

    public onTermsOfServiceClick() {
        this.router.navigateByUrl('/about/termsOfService');
    }

    public onPrivacyPolicyClick(): void {
        this.router.navigateByUrl('/about/privacyPolicy');
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-about-tour');
    // }
}
